const enumToSelectOptions = (enumObject) =>
  Object.keys(enumObject).map((value) => enumObject[value]);

export {
  // eslint-disable-next-line import/prefer-default-export
  enumToSelectOptions,
};
